import {
  ConfirmationBox,
  HeadingGroup,
  ModalLayout,
  Pagination,
  SearchFilters,
  Table,
} from "@wac-ui-dashboard/wac_component_library";
import { FaSort } from "react-icons/fa";
import OrderColumn from "../../Global/OrderColumn";
import usePermissionsList from "./usePermissionsList";
import CreateRoleModal from "./CreateRoleModal";

const PermissionsList = () => {
  const {
    userRolesList,
    userRoles,
    currentPage,
    paginationOptions,
    isFetching,
    isLoading,
    refetch,
    handlePagination,
    handlePageSize,
    handleDateChange,
    handleSort,
    handleSearch,
    getRow,
    handleEditClick,
    closeEditModal,
    showEditModal,
    handleDelete,
    showform,
    setShowform,
    showDeleteConfirm,
    setShowDeleteConfirm,
    handleDeleteAction,
    handleEditAction,
    updateTestimonialsFields,
    hasCreatePermission,
    hasDeletePermission,
    // hasViewPermission,
    hasEditPermission,
  } = usePermissionsList();

  return (
    <>
      <HeadingGroup
        title={"Permissions List"}
        className={`pro-mb-4`}
        buttonTitle={hasCreatePermission ? "Add new" : ""}
        handleClick={() => {
          setShowform(true);
        }}
      />
      <div className={`col-auto pro-pt-3 pro-pb-6`}>
        <SearchFilters
          data={userRolesList?.data?.filters}
          onDateChange={handleDateChange}
          onSearchInput={handleSearch}
          showActions={true}
          handleActionClick={handleEditClick}
          loading={isLoading}
          SearchIcon={
            <span className="material-symbols-outlined"> search </span>
          }
        />

        <Table
          multiSelect={false}
          data={userRolesList?.rows?.data || []}
          uniqueID={"id"}
          fields={userRolesList?.field}
          showCheckBox={hasEditPermission || hasDeletePermission ? true : false}
          SortIcon={<FaSort />}
          editIcon={<span className="material-symbols-outlined">edit</span>}
          deleteIcon={<span className="material-symbols-outlined">delete</span>}
          handleSort={handleSort}
          editable={hasEditPermission}
          getRow={getRow}
          loading={isFetching}
          perpage={userRoles.currentPageSize}
          assignable={false}
          handleEdit={handleEditAction}
          handleDelete={handleDelete}
          deletable={hasDeletePermission}
        />

        {userRolesList?.rows?.data?.length > 0 && (
          <Pagination
            currentPage={currentPage}
            totalPageCount={userRolesList?.rows.last_page}
            onPageChange={handlePagination}
            options={paginationOptions}
            onActionChange={handlePageSize}
            center
          />
        )}

        <ModalLayout show={showEditModal} handleClose={closeEditModal}>
          <div className="pro-m-5">
            <OrderColumn
              title={"Choose which columns you see"}
              refetchData={refetch}
              tableFields={userRolesList?.field}
              moduleId={userRolesList?.table_id}
              updateData={updateTestimonialsFields}
            />
          </div>
        </ModalLayout>

        <ModalLayout
          centered={false}
          show={showDeleteConfirm}
          handleClose={setShowDeleteConfirm}
        >
          <div className="pro-m-5">
            <ConfirmationBox
              title={`Are you sure you want to delete?`}
              isRight={true}
              cancelText={`No`}
              submitText={`Yes`}
              cancelAction={setShowDeleteConfirm}
              submitAction={handleDeleteAction}
            >
              ConfirmationBox
            </ConfirmationBox>

            {true && <span className="error-message">{true}</span>}
          </div>
        </ModalLayout>

        <ModalLayout
          centered={false}
          show={showform}
          handleClose={() => {
            setShowform(false);
          }}
          title={"Create Role"}
          closeIcon={<span className="material-symbols-outlined">close</span>}
        >
          <CreateRoleModal />
        </ModalLayout>
      </div>
    </>
  );
};

export default PermissionsList;
